import { SUPPORT_SUBJECTS } from '../types';

import { buildSupportRfiFormData } from './supportRfiFormData';

export const PREMIUM_TRIAL_DESCRIPTION = 'I would like to request access to the premium module';

export const UPSELL_REQUEST_SENT = 'Your request has been sent';

export const UPSELL_REQUEST_FAILED =
  'Could not send your request. Please try again or contact support.';

export const buildPremiumTrialFormData = (): FormData =>
  buildSupportRfiFormData({
    name: SUPPORT_SUBJECTS.PREMIUM_TRIAL,
    description: PREMIUM_TRIAL_DESCRIPTION,
    due_at: new Date().toISOString().split('T')[0],
  });
